<template>
  <div class="activity-timeline">
    <h2 class="title is-4">Activity Timeline</h2>

    <div v-if="loading" class="has-text-centered">Loading...</div>

    <div v-else>
      <div v-for="log in logs" :key="log.id" class="timeline-item">
        <div class="timeline-marker" :class="markerClass(log.action)">
          <span class="icon is-small">
            <i :class="iconClass(log.action)"></i>
          </span>
        </div>

        <div class="timeline-content">
          <p class="heading">{{ formatDate(log.created_at) }}</p>
          <p>
            <strong>{{ log.user_name || 'System' }}</strong>
            <span class="has-text-grey"> {{ log.action }}</span>
          </p>
          <p v-if="log.related_model" class="is-size-7 has-text-grey">
            {{ log.related_model }} #{{ log.related_object_id }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/axios';

export default {
  name: 'ActivityTimeline',
  data() {
    return {
      logs: [],
      loading: true,
    };
  },
  async created() {
    try {
      const response = await api.get('/organization/activities/');
      this.logs = response.data;
    } catch (err) {
      console.error('Failed to load activity logs', err);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    formatDate(dateStr) {
      const d = new Date(dateStr);
      return d.toLocaleString();
    },
    // Define CSS classes for marker colors
    markerClass(action) {
      if (!action) return 'is-grey';
      if (action.toLowerCase().includes('create')) return 'is-green';
      if (action.toLowerCase().includes('update')) return 'is-blue';
      if (action.toLowerCase().includes('delete')) return 'is-red';
      return 'is-grey';
    },
    // Define icons per action
    iconClass(action) {
      if (!action) return 'fas fa-circle';
      if (action.toLowerCase().includes('create')) return 'fas fa-plus';
      if (action.toLowerCase().includes('update')) return 'fas fa-edit';
      if (action.toLowerCase().includes('delete')) return 'fas fa-trash';
      return 'fas fa-circle';
    },
  },
};
</script>

<style scoped>
.activity-timeline {
  position: relative;
  margin-left: 1.5rem;
  border-left: 2px solid #dbdbdb;
  padding-left: 1.5rem;
}

.timeline-item {
  position: relative;
  margin-bottom: 1.5rem;
}

.timeline-marker {
  position: absolute;
  left: -1.4rem;
  top: 0.2rem;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 0 0 2px #dbdbdb;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.6rem;
  color: white;
}

/* Marker colors */
.is-green {
  background: #48c774; /* Bulma green */
}
.is-blue {
  background: #3273dc; /* Bulma blue */
}
.is-red {
  background: #f14668; /* Bulma red */
}
.is-grey {
  background: #7a7a7a; /* Bulma grey */
}

.timeline-content {
  padding-left: 0.5rem;
}
</style>
